import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { isTokenExpired, useAuthContext } from "@/contexts";

type GuestGuardProps = {
  children: ReactNode;
};

export const GuestGuard = ({ children }: GuestGuardProps) => {
  const { accessToken, isInitialized } = useAuthContext();
  const location = useLocation();

  if (!isInitialized) {
    return null;
  }

  if (accessToken && !isTokenExpired(accessToken)) {
    return <Navigate to={location.state?.from ?? "/"} />;
  }

  return <>{children}</>;
};
